import { useAuth } from "./AuthProvider.js";

export function useMe() {
  const auth = useAuth();
  return {
    me: auth.me,
    status: auth.status,
    refresh: () => auth.refresh(),
  };
}
